import {
  MotorDeSincronizacao,
  abrirBanco,
  criarCliente,
  escutarRetryAfter,
  transporteSupabase,
} from '@sheafyield/sync';

import { garantirPersistencia } from '../pwa/persistencia.js';
import { lembrarDonoDoAparelho } from '../seguranca/donoDoAparelho.js';
import { SUPABASE_PUBLISHABLE_KEY, SUPABASE_URL } from '../supabase/config.js';
import { baterHeartbeat } from './heartbeat.js';
import { ligarSessaoAoMotor, realtimeQueSegueASessao } from './sessao.js';

export const banco = abrirBanco();
// O mesmo objeto nos dois lugares: ele embrulha o `fetch` que o cliente usa
// (é o único ponto por onde o cabeçalho `Retry-After` passa — o supabase-js
// não entrega cabeçalho de resposta) e o transporte o lê na hora de montar a
// falha, para o motor esperar o que o servidor pediu em vez de adivinhar.
const escutaDeRetryAfter = escutarRetryAfter();
export const cliente = criarCliente(
  { url: SUPABASE_URL, chave: SUPABASE_PUBLISHABLE_KEY },
  banco,
  escutaDeRetryAfter.fetch,
);

export const motor = new MotorDeSincronizacao({
  banco,
  transporte: transporteSupabase(cliente, escutaDeRetryAfter),
  // O canal segue a sessão: arma no login, rearma na troca de conta e cai
  // ao sair (`sessao.ts`). Resolver a sessão uma vez só aqui deixava o
  // canal calado para sempre na primeira instalação.
  realtime: realtimeQueSegueASessao(cliente),
});

let iniciado = false;
export async function iniciarApp(): Promise<void> {
  if (iniciado) return;
  iniciado = true;
  await garantirPersistencia();
  void baterHeartbeat();
  // Registrado uma única vez, antes de o motor partir: entrar dispara um
  // ciclo, sair devolve o estado a "sem conta".
  //
  // É também daqui que a **prontidão** da adoção depende. Adotar e purgar
  // acontecem em `#assumirODono`, que o ciclo chama sempre que o dono
  // gravado difere do usuário — e ciclos vêm também do intervalo, do
  // `visibilitychange`, do `online` e da mutação local. O que corre **só**
  // por este ouvinte é a adoção no relogin da mesma conta, em que o ciclo
  // não vê diferença nenhuma e pula a chamada. Sem ele, ou com um evento de
  // sessão que não chegue, essas linhas ficam com a `CONTA_LOCAL` até a
  // próxima entrada de conta. Ver `sessao.ts` e o ADR-0006 antes de mexer na
  // ordem ou na condição desta chamada.
  ligarSessaoAoMotor(cliente, motor);
  // O dono do aparelho fica registrado ao lado da preferência da trava, e
  // não some ao sair da conta: é ele que a saída "Não consigo desbloquear"
  // exige quando não há sessão viva. Sem isto, um aparelho com a trava
  // ligada e sem sessão voltava a aceitar qualquer e-mail sobre o banco do
  // dono anterior (ver `seguranca/donoDoAparelho.ts` e o ADR-0006).
  lembrarDonoDoAparelho(cliente, banco.estado);
  await motor.iniciar();
}
